import React, { useState, useEffect, useRef } from "react";
import {
  postSkillSubject,
  updateSkillSubject,
  getSkillSubjectAPI,
} from "../../../api/skill.service";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Constant from "../../../utils/constant";
import { Link, useNavigate, useLocation } from "react-router";
import { connect } from "react-redux";
import Select from "react-select";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { toast } from "react-toastify";
import { useNumericParam } from "../../../utils/useNumericParam";

const initialState = {
  subject: "",
  grade: "",
  name: "",
  isActive: false,
  notes: "",
  scoringAlgorithm: "",
  contentAreaId: 0,
  contentAreaName: "",
  gradeLevel: "",
  gradeLevelData: { label: "Please Select Grade Level", value: 0 },
  grades: [],
  states: [],
  contentData: { label: "Please Select Content Data", value: 0 },
};
const ManagePracticeSubjects: React.FC<any> = (props: any) => {
  const [manageNotification, setManageNotification] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [loading, setLoading] = useState<boolean>(false);
  const [subName, setsubName] = useState<string>("");
  const [subCode, setsubCode] = useState<string>("");
  const [editSkill, seteditSkill] = useState<any>();
  const [isApproved, setisApproved] = useState<boolean>(false);
  const navigate = useNavigate();
  const subId = useNumericParam("id");
  const [contentData, setcontentData] = useState<any>(0);
  const [newContent, setNewContent] = useState<any>([]);
  const [lang, setLang] = useState<number>(1);
  const [eSSubName, setESSubName] = useState<string>("");

  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(pageSize, pageNumber);
    const data = (await response).data;
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setNewContent(newContentData);
  };

  useEffect(() => {
    if (subId && subId > 0) {
      getSkillSubjectAPI(subId).then((response) => {
        const contentType = {
          label: response?.data?.contentAreaName,
          value: response?.data?.contentAreaId,
        };
        seteditSkill(response.data);
        setcontentData(contentType);
      });
    }
  }, [subId]);

  useEffect(() => {
    setLoading(true);
    if (editSkill != null) {
      setsubName(editSkill.name);
      setisApproved(editSkill.isApproved);
      setsubCode(editSkill.code);
      setESSubName(editSkill.spanishName);
    }
    setLoading(false);
    getContent();
  }, [editSkill]);

  const subjectArray = {
    name: subName,
    spanishName: eSSubName,
    isActive: true,
    isApproved: isApproved,
    contentAreaId: contentData.value,
    userId: props.profile?.userId ? props.profile?.userId : 1,
    code: subCode,
  };

  const inputSubName = useRef<any>(undefined);
  const inputSubCode = useRef<any>(undefined);

  const onSumbit = () => {
    setManageNotification(true);
    if (subCode === "") {
      inputSubCode.current.focus();
    }
    if (subName === "") {
      inputSubName.current.focus();
    }
    if (subName === "" || subCode === "" || contentData.value === 0) {
      toast.warning("Data cannot be empty");
    } else {
      if (editSkill != null) {
        const editsubjectArray = {
          name: subName,
          spanishName: eSSubName,
          isActive: editSkill.isActive ? true : false,
          isApproved: isApproved,
          contentAreaId: contentData.value,
          userId: props.profile?.userId ? props.profile?.userId : 1,
          code: subCode,
          skillSubjectId: editSkill.skillSubjectId,
        };

        updateSkillSubject(editsubjectArray).then((res) => {
          setManageNotification(true);
          toast.success("Subject updated successfully");
          navigate(Constant.SKILLPRACTICESUBJECT);
        });
      } else {
        postSkillSubject(subjectArray).then((res) => {
          setManageNotification(true);
          toast.success("Subject added successfully");
          navigate(Constant.SKILLPRACTICESUBJECT);
        });
      }
    }
  };

  const updateMultiDropdownValues = (updateObj, type) => {
    if (type == "ContentArea") {
      setcontentData(updateObj);
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: " Skill Practice Subject", url: Constant.SKILLPRACTICESUBJECT },
      {
        name: editSkill
          ? "Edit Skill Practice Subject"
          : "Add  Skill Practice Subject",
        url: "",
      },
    ];

    if (editSkill?.skillSubjectId) {
      items.push({ name: editSkill?.skillSubjectId, url: "" });
    }

    return items;
  };

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  return (
    <AllowedTo
      perform={[
        Permissions.skill_practice_subject_create,
        Permissions.skill_practice_subject_modify,
      ]}
      no={() => <AccessDenied />}
    >
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {editSkill
                  ? "Edit Skill Practice Subject "
                  : "Add Skill Practice Subject"}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form>
              <div className="shadow border rounded-lg mt-4 px-4 py-6 w-1/4">
                <div className="flex justify-end">
                  <div
                    className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                    onClick={() => toggleLang()}
                  >
                    <span
                      className={`${
                        lang === 1
                          ? "bg-primary-color text-white"
                          : "bg-white text-gray-400"
                      } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                    >
                      English
                    </span>
                    <span
                      className={`${
                        lang === 2
                          ? "bg-primary-color text-white"
                          : "bg-white text-gray-400"
                      } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                    >
                      Spanish
                    </span>
                  </div>
                </div>
                <div>
                  <div className="grid grid-cols-1">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Subject Name
                        {lang === Constant.LANGUAGE.English && (
                          <span className="text-red-600">*</span>
                        )}
                      </label>
                    </div>
                    <div>
                      <input
                        value={subName}
                        type="text"
                        onChange={(e: any) => {
                          setsubName(e.target.value);
                        }}
                        ref={inputSubName}
                        className={`${
                          lang === 1 ? "" : "hidden"
                        } block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                        required
                      />

                      <input
                        type="text"
                        value={eSSubName}
                        autoComplete="off"
                        className={`${
                          lang === 2 ? "" : "hidden"
                        } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                        onChange={(e) => setESSubName(e.target.value)}
                      />

                      {subName === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Subject name is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Subject Code <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <div>
                      <input
                        id="SubjectCode"
                        name="Code"
                        value={subCode}
                        type="text"
                        onChange={(e: any) => {
                          setsubCode(e.target.value);
                        }}
                        ref={inputSubCode}
                        className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                      {subCode === "" && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Subject code is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Content Area<span className="text-red-600">*</span>
                      </label>
                    </div>
                    <div
                      id="contentAreaFilter"
                      className="mt-1 block w-full py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                    >
                      <Select
                        options={newContent}
                        value={contentData}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                        onChange={(e) => {
                          updateMultiDropdownValues(e, "ContentArea");
                        }}
                      ></Select>
                      {contentData === 0 && manageNotification === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Content area name is required
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center mt-5">
                    <div>
                      <input
                        id="isApproved"
                        name="isApproved"
                        type="checkbox"
                        checked={isApproved}
                        onChange={(e: any) => {
                          setisApproved(!isApproved);
                        }}
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                      />
                    </div>
                    <div className="text-sm ml-2">
                      <label className="font-medium text-gray-700 whitespace-nowrap">
                        Approved
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-end mt-8 items-center border-t ">
                    <button
                      type="button"
                      className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                      onClick={onSumbit}
                    >
                      {editSkill ? "Update" : "Save"}
                    </button>
                    <Link to={Constant.SKILLPRACTICESUBJECT} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(ManagePracticeSubjects);
